import React from 'react';
import './Footer.scss';

export const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__right">
        <span>
          The young interiors artist Daniel Heilig creates exclusive, hand-signed singular pieces, unique collections, and limited editions. Design adaptations can be requested from the artist.
        </span>

        <span>
            Heilig Objects 2023, all rights are reserved.
        </span>
      </div>
      <div className="footer__left"></div>
    </footer>
  )
}
